import api from '../utils/api';

export const getAllOrders = async () => {
  try {
    const response = await api.get('/orders');
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch orders');
  }
};

export const getAllDeliveryNotes = async () => {
  try {
    const response = await api.get('/delivery-notes');
    return response;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch Deliveries note');
  }
};

export const getDeliveryNotesByClient = async (clientId) => {
  try {
    const response = await api.get('/delivery-notes/find-all-by-client', {
      params: { clientId },
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch delivery notes');
  }
};


export const createDeliveryNote = async (deliveryNoteData) => {
  try {
    const response = await api.post(`/delivery-notes`, deliveryNoteData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create Delivery note');
  }
};

export const getDeliveryNotesByOrder = async (orderId) => {
  try {
    const response = await api.get(`/delivery-notes/order/${orderId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch delivery notes by order');
  }
};

export const updateDeliveryNoteStatus = async (id, status) => {
  try {
    const response = await api.put(`/delivery-notes/${id}/status`, null, {
      params: { status }   // ✅ en query param, pas dans le body
    });
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update Delivery note status');
  }
};

export const getDeliveryNoteById = async (id) => {
  try {
    const response = await api.get(`/delivery-notes/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch order');
  }
};

export const getOrderById = async (id) => {
  try {
    const response = await api.get(`/orders/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch order');
  }
};

export const getDeliveryNotesByStatus = async (status) => {
  try {
    const response = await api.get(`/delivery-notes/status/${status}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || new Error('Failed to fetch delivery notes by status');
  }
};

export const getMyDeliveryNotes = async () => {
  try {
    const response = await api.get('/delivery-notes/my-delivery-notes');
    return response.data;
  } catch (error) {
    throw error.response?.data || new Error('Failed to fetch my delivery notes');
  }
};

// ✅ Obtenir les bons de livraison du distributeur par statut
export const getMyDeliveryNotesByStatus = async (status) => {
  try {
    const response = await api.get(`/delivery-notes/my-delivery-notes/status/${status}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || new Error('Failed to fetch my delivery notes by status');
  }
};

// Distributeurs

export const getOrdersByPartner = async (clientId) => {
  try {
    const response = await api.get(`/orders/partner/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch orders by client');
  }
};

// Commercials

export const getOrdersByRetailer = async () => {
  try {
    const response = await api.get(`/orders/retailer`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch orders by commercial');
  }
};

export const getDeliveryNotesByManager = async (managerId) => {
  try {
    const response = await api.get(`/delivery-notes/manager/${managerId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch delivery notes by manager');
  }
};

export const getOrdersByPartnerExt = async (clientId) => {
  try {
    const response = await api.get(`/orders/partner-ext/${clientId}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch orders by client');
  }
};

export const getOrdersByStatus = async (status) => {
  try {
    const response = await api.get(`/orders/status/${status}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to fetch orders by status');
  }
};

export const createOrder = async (orderData) => {
  try {
    const response = await api.post(`/orders`, orderData);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to create order');
  }
};

export const updateOrderDetails = async (id, order) => {
  try {
    // Le backend attend un OrderUpdateRequest à plat :
    // { partnerId, items: [{ productId, quantity }], notes, deliveryAddress, deliveryDate }
    const response = await api.put(`/orders/${id}`, order);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update order');
  }
};

export const updateOrderStatus = async (id, data) => {
  try {
    const response = await api.put(`/orders/${id}/status`, data);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update order status');
  }
};

// export const updateOrderStatus = async (id, status, comment) => {
//   try {
//     const response = await api.put(`/orders/${id}/status?comment=${encodeURIComponent(comment)}`, { status });
//     return response.data;
//   } catch (error) {
//     throw error.response ? error.response.data : new Error('Failed to update order status');
//   }
// };

export const updateOrderItems = async (id, items) => {
  try {
    const response = await api.put(`/orders/${id}/items`, items);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to update order items');
  }
};

export const deleteOrder = async (id) => {
  try {
    const response = await api.delete(`/orders/${id}`);
    return response.data;
  } catch (error) {
    throw error.response ? error.response.data : new Error('Failed to delete order');
  }
};